/**
 * Created by Alex Aguilar on 7/29/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('structureSeatMaps', {
                parent: 'app',
                url: '/structureSeatMaps',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/structureSeatMaps.html',
                        controller: 'structureSeatMapsController',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['structureSeatMap']);
                            }],
                            tabs: ['tabService', function(tabService){
                                return tabService.getTabAircrafts('structureSeatMaps')
                            }],
                            structures: ['structureSeatMapService','$stateParams', function(structureSeatMapService,$stateParams){
                                return structureSeatMapService.getPageStructures($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('structureSeatMapNew', {
                parent: 'app',
                url: '/structureSeatMap/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/formStructureSeatMap.html',
                        controller: 'newEditStructureSeatMapController',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['structureSeatMap','category', 'seatProperty']);
                            }],
                            tabs: ['tabService', function(tabService){
                                return tabService.getTabAircrafts('structureSeatMaps')
                            }],
                            loadForm: ['structureSeatMapService', function(structureSeatMapService){
                                return structureSeatMapService.getLoadForm(0);
                            }],
                            action: [function(){
                                return "new";
                            }]
                        }
                    }
                }
            })
            .state('structureSeatMapEdit', {
                parent: 'app',
                url: '/structureSeatMap/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/formStructureSeatMap.html',
                        controller: 'newEditStructureSeatMapController',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['structureSeatMap','category', 'seatProperty']);
                            }],
                            tabs: ['tabService', function(tabService){
                                return tabService.getTabAircrafts('structureSeatMaps')
                            }],
                            loadForm: ['structureSeatMapService', '$stateParams', function(structureSeatMapService, $stateParams){
                                return structureSeatMapService.getLoadForm($stateParams.id);
                            }],
                            action: [function(){
                                return "edit";
                            }]
                        }
                    }
                }
            })
            .state('structureSeatMapDelete', {
                parent: 'structureSeatMaps',
                url: '/structureSeatMap/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/aircraft/structureSeatMap/deleteSeatStructure.html',
                        controller: 'deleteStructureSeatMapController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            structureId: [function() {
                                return $stateParams.id
                            }],
                            structure: ['structureSeatMapService', function(structureSeatMapService) {
                                return structureSeatMapService.getStructure($stateParams.id)
                            }]

                        }
                    }).result.then(function() {
                        $state.go('structureSeatMaps', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
